import Vue from "vue";
import Router from "vue-router";
import Home from "@/view/Home.vue";
import About from "@/view/About.vue";
import Downloads from "@/view/Downloads.vue";
import Custom from "@/view/Custom.vue";
import Results from "@/view/Results.vue";
import QueryDatabase from "@/view/QueryDatabase.vue";
import ViewDatabase from "@/view/ViewDatabase.vue";
Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      props: true,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
	{
      path: "/downloads",
      name: "downloads",
      component: Downloads,
    },
    {
      path: "/results/:jobtoken",
      name: "results",
      component: Results,
    },
    {
      path: "/custom",
      name: "custom",
      component: Custom,
    },
	{
		path:"/database/:queryterm",
		name:"database",
		component:ViewDatabase,
	},
	/*{
		path:"/querydb",
		name: "QueryDatabase",
		component: QueryDatabase,
	}*/
],
/*mode: 'history'*/
});
/*
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
})
*/
export default router;
